import { Injectable, Inject, RendererFactory2, Renderer2 } from "@angular/core";
import { DOCUMENT } from "@angular/common";
import { DomController } from "@ionic/angular";

interface Theme {
  name: string;
  styles: ThemeStyle[];
}

interface ThemeStyle {
  themeVariable: string;
  value: string;
}

@Injectable({
  providedIn: "root"
})
export class ThemeSwitcherService {
  private themes: Theme[] = [];
  private currentTheme = 0;
  private renderer: Renderer2;

  constructor(
    private domCtrl: DomController,
    @Inject(DOCUMENT) private document,
    renderFactory: RendererFactory2
  ) {
    this.renderer = renderFactory.createRenderer(null, null);
    this.themes = [
      {
        name: "day",
        styles: [
          { themeVariable: "--ion-color-primary", value: "#00284c" },
          { themeVariable: "--ion-color-primary-rgb", value: "72, 138, 255" },
          { themeVariable: "--ion-color-primary-contrast", value: "#ffffff" },
          {
            themeVariable: "--ion-color-primary-contrast-rgb",
            value: "255,255,255"
          },
          { themeVariable: "--ion-color-primary-shade", value: "#3f79e0" },
          { themeVariable: "--ion-color-primary-tint", value: "#00284c" },
          {
            themeVariable: "--ion-item-ios-background-color",
            value: "#ffffff"
          },
          { themeVariable: "--ion-item-md-background-color", value: "#ffffff" },
          { themeVariable: "--ion-tabbar-background-color", value: "#fff" },
          {
            themeVariable: "--ion-tabbar-ios-text-color-active",
            value: "#000000"
          },
          {
            themeVariable: "--ion-tabbar-md-text-color-active",
            value: "#000000"
          },
          { themeVariable: "--ion-background-color", value: "#00284c" }
        ]
      },
      {
        name: "night",
        styles: [
          { themeVariable: "--ion-color-primary", value: "#026a9f" },
          { themeVariable: "--ion-color-primary-rgb", value: "62, 101, 151" },
          { themeVariable: "--ion-color-primary-contrast", value: "#ffffff" },
          {
            themeVariable: "--ion-color-primary-contrast-rgb",
            value: "255,255,255"
          },
          { themeVariable: "--ion-color-primary-shade", value: "#1e2023" },
          { themeVariable: "--ion-color-primary-tint", value: "#01598e" },
          {
            themeVariable: "--ion-item-ios-background-color",
            value: "#026a9f"
          },
          { themeVariable: "--ion-item-md-background-color", value: "#026a9f" },
          {
            themeVariable: "--ion-tabbar-ios-text-color-active",
            value: "#ffffff"
          },
          {
            themeVariable: "--ion-tabbar-md-text-color-active",
            value: "#ffffff"
          },
          { themeVariable: "--ion-background-color", value: "#026a9f" }
        ]
      }
    ];
  }

  cycleTheme(): void {
    if (this.themes.length > this.currentTheme + 1) {
      this.currentTheme++;
    } else {
      this.currentTheme = 0;
    }

    // this.setTheme(this.themes[this.currentTheme].name);
  }

  setTheme(name: string): void {
    const currentTheme = this.themes.find(theme => theme.name === name);

    this.domCtrl.write(() => {
      // currentTheme.styles.forEach(style => {
      //     document.documentElement.style.setProperty(style.themeVariable, style.value);
      // });
    });

    // this.setBodyClass(name);
  }

  setBodyClass(bodyClass: string) {
    this.renderer.setAttribute(this.document.body, "class", bodyClass);
  }

  addBodyClass(bodyClass: string) {
    this.renderer.addClass(this.document.body, bodyClass);
  }

  removeBodyClass(bodyClass: string) {
    this.renderer.removeClass(this.document.body, bodyClass);
  }
}
